export type ConsentPolicyGdprCountry = string
export const consentCategoryCodes = {
  essential: 'C0001',
  performance: 'C0002',
  functional: 'C0003',
  targeting: 'C0004',
  social: 'C0005',
} as const

export type ConsentCategoryAlias = keyof typeof consentCategoryCodes
export type ConsentCategoryCode = (typeof consentCategoryCodes)[keyof typeof consentCategoryCodes]
export type ConsentStatus = 'allowed' | 'blocked'
export type ConsentPolicy = Record<ConsentCategoryAlias, ConsentStatus>

export function isConsentCategoryCode(code: string | undefined): code is ConsentCategoryCode {
  if (!code) return false
  return Object.values(consentCategoryCodes).includes(code as ConsentCategoryCode)
}

export const getConsentCategoryAliasForCode = (code: ConsentCategoryCode): ConsentCategoryAlias => {
  const categoryAlias = Object.keys(consentCategoryCodes).find(key => {
    return consentCategoryCodes[key as unknown as ConsentCategoryAlias] === code
  })
  return categoryAlias as unknown as ConsentCategoryAlias
}

export const consentPoliciesMatch = (these: ConsentPolicy, those: ConsentPolicy): boolean => {
  let matches = true
  Object.keys(these).forEach(key => {
    if (
      those[key as unknown as ConsentCategoryAlias] !==
      these[key as unknown as ConsentCategoryAlias]
    ) {
      matches = false
    }
  })
  return matches
}
